export default __webpack_public_path__ + "static/media/ProximaNova-Bold.7722451a.ttf";